module.exports = __webpack_public_path__ + "static/media/galeria-fotos-4-big.32f580e9.png";